import { render, staticRenderFns } from "./SearchForm.vue?vue&type=template&id=6156323b&"
import script from "./SearchForm.js?vue&type=script&lang=js&"
export * from "./SearchForm.js?vue&type=script&lang=js&"
import style0 from "./SearchForm.vue?vue&type=style&index=0&id=6156323b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports